var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('navbar',{attrs:{"title":_vm.text_title}}),_vm._v(" "),_c('ul',[_c('li',[_vm._v("R币："+_vm._s(this.usermoney.money))]),_vm._v(" "),_c('li',[_vm._v("R点:"+_vm._s(this.usermoney.coin)+"(时效R点:"+_vm._s(this.usermoney.time_coin)+")")]),_vm._v(" "),_c('li',[_vm._v("R点兑换")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-478f86b8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/money/money.vue
// module id = null
// module chunks = 